import React from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

@inject('store')
@observer
class Hubspot extends React.Component {
  handleMessage = (e) => {
    if (e.data.meetingBookSucceeded) {
      const { productDetails } = this.props
      const { store } = this.props
      const params = {
        first_name: store.sessionData.userData.first_name || '',
        last_name: store.sessionData.userData.last_name || '',
        email: store.sessionData.userData.email || '',
        phone: store.sessionData.userData.phone || '',
        product_id: productDetails.product_id,
        enrollment_type: productDetails.enrollment_type || 'none',
        company_id: productDetails.company_id,
        send_notification: '0',
        reengage: this.props.reengage,
        product_name: productDetails.product_name
      }
      store.enrollSubRequest(params, 'loading')
    }
  }

  UNSAFE_componentWillMount () {
    if (typeof document !== 'undefined') {
      const head = document.querySelector('head')
      const script = document.createElement('script')
      script.setAttribute('src', "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js")
      head.appendChild(script)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('message', this.handleMessage)
    }
  }

  // componentWillUnmount () {
  //   if (typeof document !== 'undefined') {
  //     const e = document.getElementById(CALENDLY_ID)
  //     e.parentNode.removeChild(e)
  //   }
  //   if (typeof window !== 'undefined') {
  //     window.removeEventListener('message', this.handleMessage)
  //   }
  // }

  render () {
    const { hubspotLink } = this.props
    const { userData } = this.props.store.sessionData
    const companyAddress = `${userData.street_address1} ${userData.street_address2} ${userData.city} ${userData.state} ${userData.zip}`
    const prefillData = `name=${userData.first_name} ${userData.last_name}&email=${userData.email}`.replace(/null/g, '')
    return (
      <div
        className="meetings-iframe-container"
        data-src={hubspotLink}
        style={{ minWidth: '320px', height: '600px' }}
      />
    )
  }
}

Hubspot.propTypes = {
  store: PropTypes.object,
  productDetails: PropTypes.object,
  hubspotLink: PropTypes.string,
  reengage: PropTypes.bool,
  product: PropTypes.object
}

export default Hubspot
